import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zacurrency',
  standalone: true
})
export class ZAcurrencyPipe implements PipeTransform {
  transform(
    value: string | number | 0,
    currencyCode = '',
    display = 'symbol',
    digitsInfo = '1.2-2',
    locale = 'en-ZA',
  ): string {
    return formatCurrency(
      Number(value) | 0,
      locale,
      getCurrencySymbol(currencyCode, 'wide'),
      currencyCode,
      digitsInfo,
    );
  }
}



